<template>
  <div class="sc-message--quick-text" >
    <!-- <div class="text-message"> -->
      <div class="sc-message--text">
      <!-- {{data}} -->
      <p v-html="data"></p>
    </div>
    <carousel
      :nav="false"
      :dots="false"
      :margin="2"
      :loop="false"
      :auto-width="true"
      :rtl="true"
      class="rich_quickreply">
      <dl v-for="(r, index) of content.quickReplies.replies" :key="index" @click="tagClicked(r.title)">
        <dd>
          <div>{{ r.title }}</div>
        </dd>
      </dl>
    </carousel>
  </div>
</template>

<script>
import TextMessage from './TextMessage'
import carousel from "v-owl-carousel";
export default {
  data() {
    return {
    };
  },
  components: {
    TextMessage,carousel
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false
    }
    // messageColors: {
    //   type: Object,
    //   required: true
    // },
    // messageStyling: {
    //   type: Boolean,
    //   required: true
    // }
  },
  computed: {
    data() {
      var contentData = {}
      contentData = this.content
      // console.log(contentData.quickReplies.title)
      // 處理 超連結 和 email
      this.$set(contentData.quickReplies, 'title', contentData.quickReplies.title)
      // console.log(contentData)
      return contentData.quickReplies.title
    },
    content() {
      return JSON.parse(this.message.msgJson);
    }
  },
  methods: {
    tagClicked(value) {
      this.$emit("tag-clicked",value)
    }
  }
};
</script>

<style scoped>
@import "./styles/quickReplayMessage.css";
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/QuickReplayMessage.vue